declare var $: any;
//system
import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { LogService } from 'src/app/services/common/log.service';
import { AlertService } from 'src/app/services/alert.service';
import { FacilityService } from 'src/app/services/facility.service';
import { AuthService } from 'src/app/services/auth.service';
import { CurrencyService } from 'src/app/services/currency.service';
import { StripeService } from 'src/app/services/stripe.service';
import { MemberService } from 'src/app/services/member.service';

//components
import { AuthBaseComponent } from 'src/app/components/auth-base/auth-base.component';
import { LoginComponent } from 'src/app/components/df-login/df-login.component';

//interfaces
import { CurrencyMeta, MenuPack } from 'src/app/models/meta';
import { MemberCurrency, Purchase, Item, MemberModel, MemberSetting, MyDrop } from 'src/app/models/member';
import { TermUnit } from 'src/app/models/enums';
import { Card, PaymentMethod, Person } from 'src/app/models/common-models';
import { PurchaseRequest, TransitionRequest } from 'src/app/models/currency';

//utils
import { Utils } from 'src/app/services/common/utils';
import {
  calendarDateToApiStartAt,
  membershipTransitionError,
  resolveMembershipStartCalendarDate,
} from '../membership-transition.helpers';

//services
import { EnvironmentService } from 'src/app/services/environment.service';

//components
import { AddCardComponent } from 'src/app/components/stripe/add-card/add-card.component';
import { AddPaymentMethodComponent } from 'src/app/components/stripe/add-payment-method/add-payment-method.component';

@Component({
  selector: 'df-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent extends AuthBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('login') loginPopup!: LoginComponent;
  private readonly _unsubscribe: Subject<any> = new Subject();
  @Input() public currencyMeta! : CurrencyMeta;
  @Input() public purchase! : Purchase;
  @Input() public myDrop! : MyDrop;
  @Output() passEntry:      EventEmitter<boolean> = new EventEmitter();
  submitted:                boolean  = false;
  initialized:              boolean  = false;
  memberCurrency!:          MemberCurrency;
  menuPacks!:               MenuPack[];
  subscriptionMenuIds!:     number[];
  paymentMethods:           PaymentMethod[] = [];
  memberInfo!:              MemberModel;
  personInfo!:              Person;
  selectedPaymentMethodId:           string = "";
  isPmDropdownOpen:           boolean = false;
  currentMember!:           any;
  memberId:                 number = 0;
  memberStripeCustomerId:   string = "";
  stripeCustomerIdSetting!: MemberSetting;
  purchaseRequest!:         PurchaseRequest;
  receiptEmail:             string = "";

  constructor(
    private router: Router
    , private logService: LogService
    , private alertService: AlertService
    , private facilityService: FacilityService
    , public activeModal: NgbActiveModal
    , private _memberService: MemberService
    , private _currencyService: CurrencyService
    , private authService: AuthService
    , private _stripeService: StripeService
    , private modalService: NgbModal
    , private _environmentService: EnvironmentService
  ) {
    super(router, logService, alertService, facilityService);
  }

  override async ngOnInit() {
    await super.ngOnInit();
    this.paymentMethods = [];
  }

  async ngAfterViewInit() {
    if(!this.isLoggedIn())
    {
      this.loginPopup.open();
    } else {
      this.memberInfo = await this._memberService.getMember();
      if(this.memberInfo)
      {
        this.personInfo = await this._memberService.getPerson();
        if(this.personInfo)
        {
          this.receiptEmail = this.personInfo.Email;
        }

        this.stripeCustomerIdSetting = await this._memberService.getMemberSetting(this.memberInfo.Id, ('stripe_customer_id' + (this._environmentService.getFacilityConfig().stripe.isSandbox ? '_test' : '')));
        if(this.stripeCustomerIdSetting && this.stripeCustomerIdSetting.Id > 0)
        {
          this.memberStripeCustomerId = this.stripeCustomerIdSetting.Value;
        }

        this.paymentMethods = await this._stripeService.getCustomerPaymentMethods(this.memberInfo.Id);
        this.computeDefaultSelected();
      }

      if(this.purchase && this.purchase.Items.length > 0)
      {
        this.subscriptionMenuIds = this.currencyMeta.Menus.filter(m => m.IsSubscription).map(m => m.Id);
        this.menuPacks = [];
      
        for (const menu of this.currencyMeta.Menus) {
          for (const menuPack of menu.MenuPacks) {
              this.menuPacks.push(menuPack);
          }
        }

        var i: number = 0;
        for(const item of this.purchase.Items)
        {
          this.purchase.Items[i] = this.fillMenuPackDetails(item);
          i++;
        }
        this.calculateTotal();
      }
      this.initialized = true;
    }
  }

  fillMenuPackDetails(item: MenuPack) : MenuPack
  {
    const menuPack = this.menuPacks.find(mp => mp.Id === item.Id);
    if(menuPack)
    {
      const pack = this.currencyMeta.Packs.find(p => p.Id === menuPack?.PackId);
      item.Name = menuPack.Name;
      item.Price = menuPack.Price;
      item.DecoyPrice = menuPack.DecoyPrice;
      item.TermDuration = menuPack.TermDuration;
      item.TermUnit = menuPack.TermUnit;
    } else {
      this.purchase.Items = this.purchase.Items.filter(i => i.Id !== item.Id);
    }

    return item;
  }

  calculateTotal()
  {
    this.purchase.Subtotal = this.purchase.SalesTax =  this.purchase.Total = 0;

    for (const item of this.purchase.Items.filter(i => i.StartOffset == 0)) {
        const pack = this.currencyMeta.Packs.find(p => p.Id === item?.PackId);
        this.purchase.Subtotal += item.Price;
        this.purchase.SalesTax += pack?.IsTaxable ? (item.Price * 6.625) / 100 : 0;
        this.purchase.Total += item.Price + (pack?.IsTaxable ? (item.Price * 6.625) / 100 : 0);
    }

    this.purchase.Subtotal = Number((this.purchase.Subtotal/100).toFixed(2));
    this.purchase.SalesTax = Number((this.purchase.SalesTax/100).toFixed(2));
    this.purchase.Total = Number((this.purchase.Total/100).toFixed(2));
  }

  getFormattedPrice(price: number)
  {
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formatter.format(price);
  }

  getTermDuration(menuPackId: number) {
    const menuPack = this.menuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      const isSubscription = this.subscriptionMenuIds.includes(menuPack.MenuId);
      if(isSubscription)
        return "per " + Utils.getEnumNameFromValue(TermUnit, menuPack.TermUnit).toLowerCase();
    }
    return "";
  }

  getPackQuantity(menuPackId: number): number {
    const menuPack = this.menuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      const pack = this.currencyMeta.Packs.find(p => p.Id === menuPack.PackId);
      if(pack)
      {
        return pack.Quantity;
      }
    }
    return 0;
  }

  getPackUnit(menuPackId: number): string {
    const qty = this.getPackQuantity(menuPackId);
    const menuPack = this.menuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      const currency = this.currencyMeta.Currencies.find(p => p.Id === menuPack.CurrencyId);
      if(currency)
      {
        if(currency.Unit.toLowerCase() == "class" || currency.Unit.toLowerCase() == "drop-pass")
          return currency.Unit + (qty > 1 ? "es" : "");
        return currency.Unit + (qty > 1 ? "s" : "");
      }
    }
    return "Unit" + (qty > 1 ? "s" : "");
  }

  hasDiscountLabel(menuPackId: number): boolean {
    const menuPack = this.menuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      const save = menuPack.DecoyPrice - menuPack.Price;
      if(save > 0)
      {
        return true;
      }
    }
    return false;
  }

  getDiscountLabel(menuPackId: number): string {
    const menuPack = this.menuPacks.find(mp => mp.Id === menuPackId);
    if(menuPack)
    {
      const save = menuPack.DecoyPrice - menuPack.Price;
      if(save > 0)
      {
        return "Save $" + (save / 100);
      }
    }
    return "";
  }

  getTax(): number {
    //todo: fix this
    return 0;
    // return this.purchase.Items[0].Tax;
  }

  removeItem(itemId: number)
  {
    this.purchase.Items = this.purchase.Items.filter(i => i.Id !== itemId);
    if(this.purchase.Items.length === 0)
      this.closeModal(true);
  }
  
  getTotalItems()
  {
    return this.purchase.Items.length + (this.purchase.Items.length > 1 ? " Items" : " Item");
  }

  private isTruthyFlag(value: any): boolean {
    if (value === true || value === false) { return value; }
    if (value === 1 || value === 0) { return !!value; }
    if (typeof value === 'string') {
      const v = value.trim().toLowerCase();
      return v === 'true' || v === '1' || v === 'yes';
    }
    return false;
  }

  private computeDefaultSelected(): void {
    // 1) Try top-level default flags
    let defaultPm = (this.paymentMethods as any[]).find(pm => this.isTruthyFlag(pm?.is_default) || this.isTruthyFlag(pm?.default));

    // 2) Prefer nested default flags if top-level not present
    if (!defaultPm) {
      defaultPm = (this.paymentMethods as any[]).find(pm =>
        ((pm?.type === 'card' || (!!pm.card && !(pm.type||'').toString())) && this.isTruthyFlag(pm?.card?.is_default)) ||
        ((pm?.type === 'us_bank_account' || pm?.type === 'bank_account' || (!!pm.us_bank_account && !(pm.type||'').toString())) && this.isTruthyFlag(pm?.us_bank_account?.is_default))
      );
    }
    console.debug('computeDefaultSelected: candidates', this.paymentMethods, 'chosen', defaultPm);
    if (defaultPm) {
      this.selectedPaymentMethodId = this.getPaymentMethodId(defaultPm);
      return;
    }

    // Fallback to first payment method
    if (!this.selectedPaymentMethodId && this.paymentMethods.length > 0) {
      this.selectedPaymentMethodId = this.getPaymentMethodId((this.paymentMethods as any[])[0]);
    }
  }

  private facilityTimeZone(): string {
    return Utils.resolveSessionTimeZone(this._environmentService.getFacilityConfig()?.timezone);
  }

  private resolveStartCalendarDate(): string {
    return resolveMembershipStartCalendarDate(this.purchase?.StartAt, this.facilityTimeZone());
  }

  private resolveStartAt(): Date {
    return calendarDateToApiStartAt(this.resolveStartCalendarDate());
  }

  checkout() {
    this.submitted = true;
    const startAt = this.resolveStartAt();
    const menuPackId = this.purchase.Items[0].Id;
    const bookingId = this.purchase?.BookingId || 0;

    if (bookingId > 0) {
      const transitionRequest: TransitionRequest = {
        MemberId: this.memberInfo.Id,
        BookingId: bookingId,
        ToMenuPackId: menuPackId,
        StripeCustomerId: this.memberStripeCustomerId,
        StripeCardId: this.selectedPaymentMethodId,
        ReceiptEmail: this.receiptEmail,
        StartAt: startAt
      };

      this._currencyService.transition(transitionRequest).subscribe((result: boolean | string) => {
        const failure = membershipTransitionError(result);
        if (failure) {
          this.submitted = false;
          this.alertService.error(failure);
          this.closeModal(false);
          return;
        }
        this.submitted = false;
        this.alertService.success('Membership updated successfully.');
        this.closeModal(true);
      });
      return;
    }

    this.purchaseRequest = {
      MemberId: this.memberInfo.Id,
      MenuPackId: menuPackId,
      StripeCustomerId: this.memberStripeCustomerId,
      StripeCardId: this.selectedPaymentMethodId,
      ReceiptEmail: this.receiptEmail,
      StartAt: startAt
    };

    this._currencyService.purchase(this.purchaseRequest).subscribe((result: boolean | string) => {
      if(typeof(result) === 'string')
      {
        this.submitted = false;
        this.alertService.error(result);
        // window.alert(result);
        this.closeModal(false);
        return;
      } else {
        this.submitted = false;
        // window.alert('Purchase successful.');
        this.alertService.success('Purchase successful.');
        this.closeModal(true);
      }
    });
  }

  closeModal(result: boolean) {
    this.passEntry.emit(result);
    this.activeModal.close(result);
  }

  isLoggedIn(): boolean {
    this.currentMember = this.authService.getLoggedInMember();
    this.memberId = this.currentMember?.Id || 0;
    return !!this.currentMember && this.currentMember.Id > 0;
  }

  loggedIn(isLoggedIn: boolean) {
    if (isLoggedIn)
    {
      if(this.isLoggedIn())
      {
        
      }
    }
  }

  openAddPaymentMethodPopup() {
    setTimeout(() => {
      //open class map popup
      const modalRef = this.modalService.open(AddPaymentMethodComponent, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        centered: true,
        fullscreen: window.innerWidth <= 768,
      });

      //Passing itemIds to popup
      modalRef.componentInstance.memberId = this.memberId;
  
      //Retrieving boolean from popup
      modalRef.result.then(async (result: boolean) => {
        this.logService.debug("card added?:", result);
        if(result)
        {
          this.paymentMethods = await this._stripeService.getCustomerPaymentMethods(this.memberInfo.Id);
          this.computeDefaultSelected();
        }
      });
    }, 500);
  }

  ngOnDestroy(): void {
    this._unsubscribe.next(null);
    this._unsubscribe.complete();
  }

  cardChangeEvent(event: Event) {
    const target = event.target as HTMLSelectElement;
    if (target.value === "new") {
      this.openAddPaymentMethodPopup();
    } else {
      this.selectedPaymentMethodId = target.value;
    }
  }

  // Helpers for custom payment method dropdown
  isDefaultPaymentMethod(pm: any): boolean {
    if (!pm) { return false; }
    const type = (pm.type || '').toString();
    if (type === 'card' || (!!pm.card && !type)) { return !!pm.card?.is_default; }
    if (type === 'us_bank_account' || type === 'bank_account' || (!!pm.us_bank_account && !type)) { return !!pm.us_bank_account?.is_default; }
    return false;
  }

  getPaymentMethodId(pm: any): string {
    if (!pm) { return ''; }
    const type = (pm.type || '').toString();
    if (type === 'card' || (!!pm.card && !type)) { return pm.card?.id || pm.id || ''; }
    if (type === 'us_bank_account' || type === 'bank_account' || (!!pm.us_bank_account && !type)) { return pm.us_bank_account?.id || pm.id || ''; }
    // Fallback to top-level id if present
    return pm.id || '';
  }

  getPaymentMethodLabel(pm: any): string {
    if (!pm) { return ''; }
    const type = (pm.type || '').toString();
    if (type === 'card' || (!!pm.card && !type)) {
      const brand = (pm.card?.brand || 'Card').toString();
      const last4 = pm.card?.last4 || '';
      return `${this.toTitleCase(brand)} •••• ${last4}`;
    }
    if (type === 'us_bank_account' || type === 'bank_account' || (!!pm.us_bank_account && !type)) {
      const bank = pm.us_bank_account?.bank_name || 'Bank Account';
      const last4 = pm.us_bank_account?.last4 || '';
      return `${bank} •••• ${last4}`;
    }
    return 'Payment Method';
  }

  getPaymentMethodIcon(pm: any): string {
    const base = 'assets/images/svg/cards/';
    if (!pm) { return base + 'card.svg'; }
    const type = (pm.type || '').toString();
    if (type === 'card' || (!!pm.card && !type)) {
      const brand = (pm.card?.brand || '').toLowerCase();
      if (brand.includes('visa')) return base + 'visa.svg';
      if (brand.includes('master')) return base + 'mastercard.svg';
      if (brand.includes('american') || brand.includes('amex')) return base + 'american_express.svg';
      if (brand.includes('discover')) return base + 'discover.svg';
      return base + 'card.svg';
    }
    // No specific bank logos available; use generic card icon as fallback
    return base + 'card.svg';
  }

  selectPaymentMethod(pm: any, event?: Event): void {
    if (event) { event.stopPropagation(); }
    const id = this.getPaymentMethodId(pm);
    console.log(pm, id);
    if (id) {
      this.selectedPaymentMethodId = id;
      this.isPmDropdownOpen = false;
    }
  }

  getSelectedPaymentMethod(): any {
    return (this.paymentMethods as any[]).find(pm => this.getPaymentMethodId(pm) === this.selectedPaymentMethodId);
  }

  togglePmDropdown(event?: Event): void {
    if (event) { event.stopPropagation(); }
    this.isPmDropdownOpen = !this.isPmDropdownOpen;
  }

  setDefaultBadge(pm: any): string {
    return this.isDefaultPaymentMethod(pm) ? ' (Default)' : '';
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.isPmDropdownOpen) {
      this.isPmDropdownOpen = false;
    }
  }

  private toTitleCase(text: string): string {
    return text.replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.substr(1).toLowerCase());
  }
}

